module.exports = __webpack_public_path__ + "static/img/mobilestep2.d28839c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/mobilestep2.png
// module id = /ejc
// module chunks = 1